export const isNoInternetConnectionError = (
  error:
    | {
        message: string;
      }
    | null
    | undefined
) => {
  return (
    error?.message.includes('Failed to fetch') || // fetch() error
    error?.message === 'Network Error' // axios generic error
  );
};
